// Tiny toast — store action setToast() pushes; auto-dismiss after 2.8s
// is handled in store.tsx. Floats bottom-center.

import { useStore } from "@/lib/store";
import { cn } from "@/lib/utils";

export function Toast() {
  const { toast } = useStore();
  if (!toast) return null;
  return (
    <div
      className={cn(
        "fixed bottom-6 left-1/2 -translate-x-1/2 z-50",
        "rounded-full border px-5 py-2.5 text-sm shadow-card-hover",
        "animate-fade-in",
        toast.kind === "error"
          ? "border-destructive/30 bg-destructive/10 text-destructive"
          : "border-border bg-card text-foreground"
      )}
    >
      {toast.text}
    </div>
  );
}
